module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "breadcrumb is-small",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n              Home\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'playlists'
      }
    }
  }, [_vm._v("\n              Playlists\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s("New"))])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("New song for " + _vm._s(_vm.playlist.name))])]), _vm._v(" "), _c('playlist-item-edit')], 1)]), _vm._v(" "), _c('a', {
    staticClass: "add button is-large is-warning",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-medium"
  }, [_c('i', {
    staticClass: "fas fa-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fe3e8e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewPlaylistItem.vue
// module id = 315
// module chunks = 2